export enum BookingStatus {
  Active = 0,
  Cancelled = 1
}
